import React, { useState, useEffect, useRef } from 'react';
import { useHistory } from 'react-router';
import { Container } from '@material-ui/core';
import { LOGOUT } from 'ConstComponents';
import { SelectURL as SELECT_URL } from 'Components/Api/MahagramAEPSAPI';

import { FailTransactionResponse } from 'Components/Alert/FailTransactionResponse';
import HOCLoader from 'Components/Loader/HOCLoader';
const CustomContainer = HOCLoader(Container);

export const MahagramAEPS = () => {
    const history = useHistory();

    const formRef = useRef();

    const [loading, setLoading] = useState(false);
    const [responseMessage, setResponseMessage] = useState('');
    const [isError, setIsError] = useState(false);
    const [severity, setSeverity] = useState('success');
    const [URL, setURL] = useState('');
    const [status, setStatus] = useState('PROCESS');
    const [Message, setMessage] = useState('');

    const [isAlertErrorOpen, setIsAlertErrorOpen] = useState(false);
    const selectURL = async () => {
        setResponseMessage('');
        const response = await SELECT_URL();

        setLoading(false);
        if (!response.isAuthorized) LOGOUT();

        if (!response.status) {
            setResponseMessage(response.data);
            setIsError(true);

            setStatus('FAILURE');
            setMessage(response.data);
            setIsAlertErrorOpen(true);
            if (response.data === 'User not onboarded') {
                history.push('/MRegistration');
                return;
            }
            return;
        }

        var data = JSON.parse(response.data);

        setSeverity('success');
        setURL(data.URL);
        formRef.current.submit();
    };

    useEffect(() => {
        selectURL();
    }, []);

    return (
        <CustomContainer
            isLoading={loading}
            isError={isError}
            alertMessage={responseMessage}
            severity={severity}
            onCloseCallback={(alertState) => {
                setIsError(alertState);
            }}
        >
            <form ref={formRef} method="post" action={URL} target="_blank">
                <input
                    type="submit"
                    value="Redirect"
                    style={{ display: 'none' }}
                />
            </form>

            {isAlertErrorOpen ? (
                <FailTransactionResponse
                    isOpen={isAlertErrorOpen}
                    title={status}
                    Message={Message}
                    OkButtonClick={(request) => {
                        setIsAlertErrorOpen(false);
                    }}
                />
            ) : null}
        </CustomContainer>
    );
};
